export default "__VITE_ASSET__DEYqNZQR__"